<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadServers(1, null, true)">
      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addServer">{{ $t('add_server') }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('domain')" v-model="serversSearchParams.domain" class="w-full"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('cti_login_url')" v-model="serversSearchParams.cti_login_page_url" class="w-full"/>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadServers(1, null, true)" v-text="$t('search')"></vs-button>
      </template>
    </vx-card>

    <vx-card id="serverDataContainer" :title="$tc('server', 2)" class="mb-8 vs-con-loading__container">
      <template slot="actions">
        <shared-servers-tab-nav></shared-servers-tab-nav>
      </template>

      <vs-table class="table-servers" hover-flat v-if="servers && servers.length" :data="servers">
        <template slot="thead">
          <vs-th v-text="$t('no')"></vs-th>
          <vs-th>{{ $t('name') }}</vs-th>
          <vs-th>{{ $t('domain') }}</vs-th>
          <vs-th>{{ $t('cti_login_url') }}</vs-th>
          <vs-th class="text-center" v-text="$t('action')"></vs-th>
        </template>

        <template slot-scope="{data}">
          <template v-for="(tr, key) in data">
            <vs-tr :key="'item_1_' + key">
              <vs-td v-text="tr.count"></vs-td>
              <vs-td><span v-text="tr.name"></span></vs-td>
              <vs-td><span v-text="tr.domain"></span></vs-td>
              <vs-td>
                <template v-if="tr.cti_login_page_url != null && tr.cti_login_page_url.length > 0">
                  {{ tr.cti_login_page_url }}
                  &nbsp;
                  <a :href="tr.cti_login_page_url" target="_blank">
                    <span class="fa fa-external-link-alt"></span>
                  </a>
                </template>
                <span v-else>--</span>
              </vs-td>
              <vs-td class="text-center">
                <div class="flex justify-center">
                  <vs-button color="primary" type="border" icon-pack="feather" icon="icon-edit" size="small" @click.prevent="editServer(tr.id)"></vs-button>&nbsp;
                  <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small" @click.prevent="deleteServer(tr.id)"></vs-button>
                </div>
              </vs-td>
            </vs-tr>
            <vs-tr :key="'item_2_' + key">
              <vs-td colspan="5">
                <div class="vx-row w-full">
                  <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
                    <vs-divider position="left">{{ $t('databases') }}</vs-divider>
                    <vs-table class="table-database" hover-flat v-if="tr.databases && tr.databases.length" :data="tr.databases">
                      <template slot="thead">
                        <vs-th v-text="$t('type')"></vs-th>
                        <vs-th v-text="$t('table_name')"></vs-th>
                        <vs-th v-text="$t('db_name')"></vs-th>
                        <vs-th v-text="$t('label')"></vs-th>
                      </template>

                      <template slot-scope="{data}">
                        <vs-tr :key="key" v-for="(database, key) in data">
                          <vs-td v-text="database.database_type.name"></vs-td>
                          <vs-td v-text="database.pivot.table_name"></vs-td>
                          <vs-td v-text="database.name"></vs-td>
                          <vs-td v-text="database.label"></vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                    <span v-else>{{ $t('no_database_yet') }}.</span>
                  </div>
                  <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
                    <vs-divider position="left">{{ $tc('node', 2) }}</vs-divider>
                    <vs-table class="table-nodes" hover-flat v-if="tr.nodes && tr.nodes.length" :data="tr.nodes">
                      <template slot="thead">
                        <vs-th v-text="$t('type')"></vs-th>
                        <vs-th v-text="$t('domain')"></vs-th>
                        <vs-th v-text="$t('port')"></vs-th>
                        <vs-th v-text="$t('namespace')"></vs-th>
                        <vs-th v-text="$t('label')"></vs-th>
                      </template>

                      <template slot-scope="{data}">
                        <vs-tr :key="key" v-for="(node, key) in data">
                          <vs-td v-text="node.node_type.name"></vs-td>
                          <vs-td v-text="node.domain"></vs-td>
                          <vs-td v-text="node.port"></vs-td>
                          <vs-td v-text="node.pivot.namespace"></vs-td>
                          <vs-td v-text="node.label"></vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                    <span v-else>{{ $t('no_node_yet') }}.</span>
                  </div>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </template>
      </vs-table>
      <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
        <div v-text="$t('no_record')"></div>
      </vs-alert>

      <template slot="footer">
        <paginate
          :total="serverPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadServers"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>
    </vx-card>

    <modal :title="$t('add_server')" :active.sync="modals.add" size="lg">
      <div class="mb-3">
        <vs-input :label="$t('name')" :placeholder="$t('name')" v-model="serverFormData.name" class="w-full"/>
        <validation-error :model-error="serverFormErrors.name"></validation-error>
      </div>
      <div class="mb-3">
        <vs-input :label="$t('domain')" :placeholder="$t('domain')" v-model="serverFormData.domain" class="w-full"/>
        <validation-error :model-error="serverFormErrors.domain"></validation-error>
      </div>
      <div class="mb-3">
        <vs-input :label="$t('cti_login_url')" :placeholder="$t('cti_login_url')" v-model="serverFormData.cti_login_page_url" class="w-full"/>
        <validation-error :model-error="serverFormErrors.cti_login_page_url"></validation-error>
      </div>

      <div class="mb-4">
        <h5>Node Servers</h5>
        <hr class="mb-3 mt-1 text-gray">

        <div class="vx-row w-full" v-for="(server, serverKey) in serverFormData.nodes" :key="serverKey">
          <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
            <div class="mb-3">
              <label class="vs-input--label" v-text="$t('node_type')"></label>
              <v-select :options="nodeTypeOptions" :reduce="label => label.value" :placeholder="$t('node_type')" v-model="server.node_type_id" class="md:mb-0" />
            </div>
          </div>

          <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
            <vs-input :label="$t('namespace')" :placeholder="$t('namespace')" v-model="server.namespace" class="w-full mb-3"/>
          </div>
        </div>

        <vs-button color="primary" type="filled" @click.prevent="addNodeServer">Add Node Server</vs-button>
      </div>

      <div>
        <h5>Databases</h5>
        <hr class="mb-3 mt-1 text-gray">

        <div class="vx-row w-full" v-for="(database, databaseKey) in serverFormData.databases" :key="databaseKey">
          <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
            <div class="mb-3">
              <label class="vs-input--label" v-text="$t('database_type')"></label>
              <v-select :options="databaseOptions" :reduce="label => label.value" :placeholder="$t('database_type')" v-model="database.id" class="md:mb-0" />
            </div>
          </div>

          <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
            <vs-input :label="$t('table_name')" :placeholder="$t('table_name')" v-model="database.table_name" class="w-full mb-3"/>
          </div>
        </div>

        <vs-button color="primary" type="filled" @click.prevent="addDatabase">Add Database</vs-button>
      </div>

      <vs-divider></vs-divider>

      <div class="flex justify-end">
        <vs-button id="addServerButton" color="primary" type="filled" @click.prevent="submitServer">{{ $t('save') }}</vs-button>
      </div>
    </modal>

    <modal :title="$t('edit_server')" :active.sync="modals.edit" size="lg">
      <div id="serverEditFormDataContainer" class="vs-con-loading__container">
        <div class="mb-3">
          <vs-input :label="$t('name')" :placeholder="$t('name')" v-model="serverFormData.name" class="w-full"/>
          <validation-error :model-error="serverFormErrors.name"></validation-error>
        </div>
        <div class="mb-3">
          <vs-input :label="$t('domain')" :placeholder="$t('domain')" v-model="serverFormData.domain" class="w-full"/>
          <validation-error :model-error="serverFormErrors.domain"></validation-error>
        </div>
        <div class="mb-3">
          <vs-input :label="$t('cti_login_url')" :placeholder="$t('cti_login_url')" v-model="serverFormData.cti_login_page_url" class="w-full"/>
          <validation-error :model-error="serverFormErrors.cti_login_page_url"></validation-error>
        </div>

        <div class="mb-4">
          <h5>Node Servers</h5>
          <hr class="mb-3 mt-1 text-gray">

          <div class="vx-row w-full" v-for="(server, serverKey) in serverFormData.nodes" :key="serverKey">
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
              <div class="mb-3">
                <label class="vs-input--label" v-text="$t('node_type')"></label>
                <v-select :options="nodeTypeOptions" :reduce="label => label.value" :placeholder="$t('node_type')" v-model="server.node_type_id" class="md:mb-0" />
              </div>
            </div>

            <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
              <vs-input :label="$t('namespace')" :placeholder="$t('namespace')" v-model="server.namespace" class="w-full mb-3"/>
            </div>
          </div>

          <vs-button color="primary" type="filled" @click.prevent="addNodeServer">Add Node Server</vs-button>
        </div>

        <div>
          <h5>Databases</h5>
          <hr class="mb-3 mt-1 text-gray">

          <div class="vx-row w-full" v-for="(database, databaseKey) in serverFormData.databases" :key="databaseKey">
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
              <div class="mb-3">
                <label class="vs-input--label" v-text="$t('database_type')"></label>
                <v-select :options="databaseOptions" :reduce="label => label.value" :placeholder="$t('database_type')" v-model="database.id" class="md:mb-0" />
              </div>
            </div>

            <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
              <vs-input :label="$t('table_name')" :placeholder="$t('table_name')" v-model="database.table_name" class="w-full mb-3"/>
            </div>
          </div>

          <vs-button color="primary" type="filled" @click.prevent="addDatabase">Add Database</vs-button>
        </div>

        <vs-divider></vs-divider>

        <div class="flex justify-end">
          <vs-button id="editServerButton" color="primary" type="filled" @click.prevent="updateServer">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import SharedServersTabNav from '@/views/Shared/Servers/TabNav'
import Paginate from '@/components/Paginate'
import Modal from '@/components/Modal'
import Pagination from '@/mixins/paginate'
import Server from '@/models/Server'

export default {
  name: 'Admin.Servers.Servers',
  mixins: [Pagination],
  components: {
    SharedServersTabNav,
    Paginate,
    Modal
  },
  data () {
    return {
      servers: {},
      serverPages: 0,
      databaseOptions: [],
      nodeTypeOptions: [],
      serverFormData: {
        name: '',
        domain: '',
        cti_login_page_url: '',
        databases: [
          {
            table_name: '',
            id: ''
          }
        ],
        nodes: [
          {
            node_type_id: '',
            domain: '',
            port: '',
            namespace: ''
          }
        ]
      },
      itemPerPage: null,
      serverFormErrors: [],
      serversSearchParams: {
        domain: '',
        cti_login_page_url: ''
      },
      modals: {
        add: false,
        edit: false
      }
    }
  },
  watch: {
    'modals.add' (val) {
      if (!val) {
        this.resetServerForm()
      }
    },
    'modals.edit' (val) {
      if (!val) {
        this.resetServerForm()
      }
    }
  },
  mounted () {
    this.loadServers(this.initialPage, null)
  },
  methods: {
    async loadServers (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#serverDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      const response = await Server.findAll({ ...this.serversSearchParams, page, itemPerPage })
      this.servers = response.data.data
      this.serverPages = response.data.meta.pagination.last_page
      this.databaseOptions = response.data.meta.options.databases
      this.nodeTypeOptions = response.data.meta.options.nodeTypes
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#serverDataContainer > .con-vs-loading')
    },
    addServer () {
      this.modals.add = true
    },
    async submitServer () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addServerButton', scale: 0.45})

      try {
        const response = await Server.store(this.serverFormData)

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.modals.add = false

        this.loadServers(1, null)
        this.resetServerForm()
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.serverFormErrors = errors.validationErrors
      }

      this.$vs.loading.close('#addServerButton > .con-vs-loading')
    },
    async editServer (id) {
      this.$vs.loading({container: '#serverEditFormDataContainer'})

      try {
        this.modals.edit = true
        const response = await Server.view({ id })
        this.serverFormData = response.data.server
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }

      this.$vs.loading.close('#serverEditFormDataContainer > .con-vs-loading')
    },
    async updateServer () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#editServerButton', scale: 0.45})

      try {
        const response = await Server.update(this.serverFormData)

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.modals.edit = false

        this.loadServers()
        this.resetServerForm()
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.serverFormErrors = errors.validationErrors
      }

      this.$vs.loading.close('#editServerButton > .con-vs-loading')
    },
    async deleteServer (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        try {
          const response = await Server.destroy({ id })

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.loadServers(1, null)
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    },
    addNodeServer () {
      this.serverFormData.nodes.push({
        node_type_id: '',
        domain: '',
        port: '',
        namespace: ''
      })
    },
    addDatabase () {
      this.serverFormData.databases.push({
        table_name: '',
        id: ''
      })
    },
    resetServerForm () {
      this.serverFormData = {
        name: '',
        domain: '',
        cti_login_page_url: '',

        databases: [
          {
            table_name: '',
            id: ''
          }
        ],

        nodes: [
          {
            node_type_id: '',
            domain: '',
            port: '',
            namespace: ''
          }
        ]
      }
      this.serverFormErrors = []
    }
  }
}
</script>

<style lang="scss">
  #addServerButton,
  #editServerButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
